import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const r = await register(email, password, name);
    setLoading(false);
    if (r.ok) navigate("/");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-[var(--omni-surface)]">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo size="lg" /></div>
        <div className="bg-white border border-[var(--omni-border)] rounded-2xl p-8">
          <h1 className="text-2xl font-bold mb-1">Créer un compte</h1>
          <p className="text-sm text-gray-500 mb-6">Quelques secondes, sans tracker.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="name" className="text-xs">Nom</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-1" data-testid="register-name-input" />
            </div>
            <div>
              <Label htmlFor="email" className="text-xs">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="register-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs">Mot de passe (min 6 caractères)</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="register-password-input" />
            </div>
            {error && <div className="text-sm text-red-600" data-testid="register-error">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full bg-[var(--omni-accent)] hover:bg-[var(--omni-accent-hover)] text-white rounded-full">
              {loading ? "Création…" : "Créer mon compte"}
            </Button>
          </form>
          <div className="text-center text-sm text-gray-500 mt-6">
            Déjà inscrit ? <Link to="/login" className="text-black font-medium" data-testid="link-login">Se connecter</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
